import { WishList, WishLists } from '../interfaces/wish-list-items.interface';

/**
 * Filters wish lists based on a keyword.
 *
 * If no keyword is provided, all wish lists are returned.
 *
 * @param keyword
 * @param wishLists
 */
export function getFilteredWishLists(keyword?: string, wishLists?: WishLists): WishList[] {
  if (!wishLists || !wishLists.items) {
    return [];
  }

  return wishLists.items.filter(
    (wishList: WishList) => !keyword || compareWishListNameToKeyword(keyword, wishList?.name ?? '')
  );
}

/**
 * Determines if the wish list name is in the search.
 *
 * @param keyword
 * @param wishListName
 */
function compareWishListNameToKeyword(keyword: string, wishListName: string): boolean {
  return new RegExp(keyword, 'i').test(wishListName);
}
